export default (props, e) => {
	const target = (document.querySelector(e.target.getAttribute('href')));
	const h2 = target.querySelector('h2');

	if (target) {
		e.preventDefault();
		target.scrollIntoView({behavior: 'smooth'});
		if (h2) {
      h2.click();
    }
	}
};




// WEBPACK FOOTER //
// ./fe/web-default/src/js/actions/scrollToHref.js